<template>
	<div>
		<div class="panel">
			<div class="panel-heading">
				<div class="btn-toolbar pull-right" role="toolbar">
					<div class="btn-group" role="group" aria-label="...">
						<button v-on:click="$refs.create.open()" type="button" class="btn btn-success btn-circle">
							<i aria-hidden="true" class="fa fa-plus"></i>
						</button>
					</div>
				</div>
				<h3 class="m-t-0 font-medium">{{ $t('resources.comments') }}</h3>
			</div>
			<div class="panel-body">
				<div v-if="comments">
					<div v-if="comments.length" class="panel-body">
						<div v-for="comment in comments" class="well">
							<div>
								{{ comment.content }}
							</div>
							<span v-if="comment.author">
								<small>
									{{ comment.author.email }}
								</small>
							</span>
							<span v-if="comment.created_at">
								<small>
									{{ comment.created_at | moment }}
								</small>
							</span>
							<span v-if="comment.updated_at">
								<small>
									Editado: {{ comment.updated_at | moment }}
								</small>
							</span>
							<!--
							<div v-if="canEdit(comment)" class="btn-toolbar pull-right" role="toolbar">
								<div class="btn-group" role="group" aria-label="...">
									<button v-on:click="$refs.edit.open(comment)" type="button" class="btn btn-info">
										<i class="fa fa-pencil-square-o" aria-hidden="true"></i>
									</button>
								</div>
							</div>
							-->
						</div>
					</div>
				</div>
			</div>
		</div>
		<create
			@reload="reload"
			ref="create"
			:resource="resource"
			:user="user"
			:isAuth="isAuth">
		</create>

		<edit
			@reload="reload"
			ref="edit"
			:user="user"
			:isAuth="isAuth"
			:resource="resource">
		</edit>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Create from './../views/Create.vue'
	import Edit from './../views/Edit.vue'

	export default {
		props: ['user', 'isAuth', 'resource'],

		components: {
			'create': Create,
			'edit': Edit,
		},
		data () {
			return {
				comments: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			reload () {
				this.$emit('reload')
				this.getData()
			},
			init() {
				this.getData()
			},
			getData () {
				this.$http.get(this.resource + '/comments')
				.then(response => {
					this.comments = response.body
				}).catch(function(response) {
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning"
					});
				})
			},
			canEdit(comment) {
				return true
				if(comment.updated_at) {
					return false
				}

				var now = moment();
				var created_at = moment(comment.created_at).add(10, 'minutes')

				return now.diff(created_at) < 0
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/cms/comments/layout/Comments.vue